import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=f9db4116&scoped=true"
import script from "./Messaging.vue?vue&type=script&lang=ts"
export * from "./Messaging.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9db4116",
  null
  
)

export default component.exports